module.exports = __webpack_public_path__ + "img/claims.f1157d33.svg";